module.exports = __webpack_public_path__ + "static/media/0.a22b2cfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/special/0.png
// module id = 1546
// module chunks = 0